// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__4wRun","background":"Hero_background__IjEQ_","parallaxmove":"Hero_parallaxmove__lDkHb","parallaxzoomoutdesktop":"Hero_parallaxzoomoutdesktop__sAfip"};